import "../../styles/all.css";
import "./client.css";
import avatarone from "../../img/avatar-02.png";
import avatartwo from "../../img/avatar-03.png";
import avatarthree from "../../img/avatar-04.png";
import avatarfour from "../../img/avatar-05.png";
import avatarfive from "../../img/avatar-06.png";
import { useTranslation } from "react-i18next";


function Client() {
        const { t } = useTranslation();

  return (
    <>
      <div className="client" data-aos="flip-up">
  <div className="client_start">
    <h4>{t("name_client")}</h4>
    <h4>{t("text_client")}</h4>
  </div>

  <div className="content">
    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatarone} className="w-50 rounded-pill mb-2" alt={t("oneperson")} />
        <h5>{t("oneperson")}</h5>
        <h6>{t("track_one")}</h6>
      </div>
      <p>{t("text_person")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star-half-stroke" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>

    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatartwo} className="w-50 rounded-pill mb-2" alt={t("twoperson")} />
        <h5>{t("twoperson")}</h5>
        <h6>{t("track_two")}</h6>
      </div>
      <p>{t("text_twoperson")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-regular fa-star" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>

    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatarthree} className="w-50 rounded-pill mb-2" alt={t("threeperson")} />
        <h5>{t("threeperson")}</h5>
        <h6>{t("track_three")}</h6>
      </div>
      <p>{t("text_threeperson")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star-half-stroke" style={{ color: "#FFD43B" }}></i>
        <i className="fa-regular fa-star" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>

    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatarfour} className="w-50 rounded-pill mb-2" alt={t("fourperson")} />
        <h5>{t("fourperson")}</h5>
        <h6>{t("track_four")}</h6>
      </div>
      <p>{t("text_fourperson")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-regular fa-star" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>

    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatarfive} className="w-50 rounded-pill mb-2" alt={t("fiveperson")} />
        <h5>{t("fiveperson")}</h5>
        <h6>{t("track_five")}</h6>
      </div>
      <p>{t("text_fiveperson")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star-half-stroke" style={{ color: "#FFD43B" }}></i>
        <i className="fa-regular fa-star" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>

    <div className="box p-2 text-center rounded">
      <div className="info">
        <img src={avatarthree} className="w-50 rounded-pill mb-2" alt={t("sixperson")} />
        <h5>{t("sixperson")}</h5>
        <h6>{t("track_six")}</h6>
      </div>
      <p>{t("text_sixperson")}</p>
      <div className="icon">
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star" style={{ color: "#FFD43B" }}></i>
        <i className="fa-solid fa-star-half-stroke" style={{ color: "#FFD43B" }}></i>
        <i className="fa-regular fa-star" style={{ color: "#FFD43B" }}></i>
      </div>
    </div>
  </div>
</div>
    </>
  );
}

export default Client;